const SERVER_URL = "https://goaldex.ai"       //"http://147.93.97.66"; // "https://goaldex.ai";
const BASE_URL = "https://goaldex.ai" // "http://147.93.97.66"; // "https://goaldex.ai";









module.exports = {
    SERVER_URL, BASE_URL
}
